// Profile Detail mutations
const profileListSetter = (state, data) => (state.profileList = data);

const setEditProfileData = (state, data) => (state.editProfileData = data);

const setViewProfileData = (state, data) => {
  localStorage["profile-type"] = data.profileType;
  const user = localStorage.getItem("user-permissions")
   user === '"player"' ? localStorage["profile-id"] = data.id : null;
  state.viewProfileData = data;
};

const addProfile = (state, data) => (
  (state.profileId = data.id),
  (state.profileList = [...state.profileList, data])
);

const loading = (state, data) => {
  state.loading = data
}

export default {
  profileListSetter,
  setEditProfileData,
  setViewProfileData,
  addProfile,
  loading,
};
